import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState, useProductFilters } from "@nosto/preact"

export default function Products({ isSidebarVisible }) {
    const {
        response: { products },
        loading
    } = useAppState()

    if(document.querySelector('.ns-close-interest-box')){
        document.querySelector('.ns-close-interest-box').click()
    }

    document.body.classList.remove('ns-block-scroll')

    const { filters } = useProductFilters();
    
    console.log(products)
    return (
        <div
            class={!isSidebarVisible ? "ns-sidebar-hidden" : "ns-sidebar-shown"}
            style={loading ? "opacity: 0.3;" : ""}
        >

            {products?.hits?.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} isSidebarVisible={isSidebarVisible} />
            })}
        </div>
    )
}
